<template>
  <a
    class="jiffy-poromotion-transfers js-jiffy-promotion"
    href="/transfers"
    :target="openInSameTab ? '_self' : '_blank'"
    data-mixpanel-listen="click"
    data-mixpanel-event="crosssell_cta_transfers_credits_offer_click"
    :data-mixpanel-data="
      JSON.stringify({
        page: 'cart',
        business_line_promo_type: 'Transfers',
        promotion_name: `spend_${spendThreshold}_get_store_credit`
      })
    "
  >
    <div class="jiffy-poromotion-transfers__store-credit-wrapper">
      <span class="jiffy-poromotion-transfers__store-credit-value">
        {{ n(creditValue, "currencyNoCents") }}
      </span>
      <span>STORE CREDIT</span>
    </div>
    <div class="jiffy-poromotion-transfers__info-wrapper">
      <div class="jiffy-poromotion-transfers__info">
        <UseSvg class="jiffy-poromotion-transfers__logo-icon" icon="jiffy-transfers-inline" />
        <p class="jiffy-poromotion-transfers__info-text">
          New to JiffyTransfers? Spend {{ n(spendThreshold, "currencyNoCents") }}+ on blank apparel,
          <strong>
            get {{ n(creditValue, "currencyNoCents") }} in store credit to try it out!
          </strong>
        </p>
      </div>
    </div>
  </a>
</template>

<script>
import { n } from "components/jiffy/vue-cart/helpers/currency";
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";

export default {
  name: "JiffyPromotionTransfers",
  components: { UseSvg },
  props: {
    creditValue: {
      type: Number,
      required: true
    },
    spendThreshold: {
      type: Number,
      required: true
    },
    openInNewTab: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isMobileApp() {
      return Boolean(window.MOBILE_APP);
    },
    openInSameTab() {
      return this.isMobileApp || !this.openInNewTab;
    }
  },
  setup() {
    return { n };
  }
};
</script>

<style lang="scss" scoped>
@import "frontend/init/jiffy/settings.scss";

.jiffy-poromotion-transfers {
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  gap: 16px;
  background-color: $lighter-pink;
  min-height: 90px;
  padding: 8px;
  border-radius: 6px;
  min-width: 380px;
  color: $text-black;
  text-decoration: none;

  &__store-credit-wrapper {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 8px 0;
    flex-basis: 100px;
    height: auto;
    gap: 2px;
    border: $crafterpay-primary-700 2px solid;
    border-radius: 6px;
    font-size: 17px;
    font-weight: 700;
    line-height: 15px;
    background: linear-gradient(180deg, $white 0%, $white-darker 100%);
  }

  &__store-credit-value {
    font-size: 30px;
    font-weight: 700;
    line-height: 100%;
  }

  &__info-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 23px;
    flex: 1;
  }

  &__info {
    font-size: 16px;
    font-weight: 400;
    line-height: 21px;
  }

  &__info-text {
    margin: 0;
    padding: 0;
  }

  &__logo-icon {
    width: 182px;
    height: 20px;
    margin-bottom: 8px;
  }
}
</style>
